module.exports = __webpack_public_path__ + "static/editmode-ab7843ae5f95e14a4d0059aba103850a.png";